import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';

import { acceptTerms, getCurrentTerms } from '../api/users';
import PortalSessionContext from '../contexts/PortalSessionContext/PortalSessionContext';
import useAsyncAction from '../hooks/useAsyncAction';
import Loader from './Loader';
import LoadingButton from './LoadingButton';
import ReusableModal from './ReusableModal/ReusableModal';

const TAndCModal = (props: Props) => {
	const [loading, error, performAction] = useAsyncAction(true);
	const [currentTerms, setCurrentTerms] = React.useState<CurrentTerms>();
	const { refreshPortalUser } = React.useContext(PortalSessionContext);

	React.useEffect(() => {
		performAction(async () => {
			const finishedCurrentTermsPromise = await getCurrentTerms();
			setCurrentTerms(finishedCurrentTermsPromise.data);
		});
	}, []);

	const handleAcceptTermsClick = async () => {
		await acceptTerms(currentTerms?.version as string);
		await refreshPortalUser();
		props.onClose();
	};

	return (
		<ReusableModal title="Terms and Conditions">
			{!loading ? (
				<div
					style={{
						color: 'black',
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						alignContent: 'center',
					}}
				>
					<TermsP>
						We have updated our Terms and Conditions. Please review the information using the link below and accept the
						Terms to continue using PlayUp. If you do not agree to all the Terms and Conditions, then you may not access
						the website or use any of it's services.
					</TermsP>

					<TermsLink href={currentTerms?.url} target="_blank">
						Terms & Conditions
					</TermsLink>

					<TermsP>
						{currentTerms?.version} - Updated {dayjs(currentTerms?.updated_at).format('MM/DD/YYYY')}
					</TermsP>

					<LoadingButton className=" _btn _btn-primary" onClick={async () => await handleAcceptTermsClick()}>
						Accept Terms & Conditions
					</LoadingButton>
				</div>
			) : (
				<Loader />
			)}
		</ReusableModal>
	);
};
export default TAndCModal;

const TermsLink = styled.a`
	font-size: 22px;
	font-weight: bold;
	text-decoration: underline;
	margin: auto;
`;

const TermsP = styled.p`
	margin: auto;
	padding-top: 15px;
	padding-bottom: 20px;
`;

interface Props {
	onClose: () => void;
}
